import api from "../utils/api";
import { SUBSCRIPTION_COST } from "../constants/routes";
import localStorageService from "./localStorageService";

export type SubscriptionCostResponse = {
  sport_code?: string;
  sportCode?: string;
  cost?: number;
  amount?: number;
  price?: number;
  currency?: string;
  currency_code?: string;
  currencyCode?: string;
  [key: string]: any;
};

export function parseSubscriptionCost(data: any): { cost: number | null; currency: string | null } {
  const rawCost = data?.cost ?? data?.amount ?? data?.price ?? data?.data?.cost ?? data?.data?.amount ?? data?.data?.price;
  const costNum = typeof rawCost === "number" ? rawCost : Number(rawCost);
  const cost = Number.isFinite(costNum) ? costNum : null;

  const rawCurrency =
    data?.currency ??
    data?.currency_code ??
    data?.currencyCode ??
    data?.data?.currency ??
    data?.data?.currency_code ??
    data?.data?.currencyCode;
  const currency = rawCurrency ? String(rawCurrency).toUpperCase() : null;

  return { cost, currency };
}

class SubscriptionCostService {
  private inflightRequests = new Map<string, Promise<any>>();

  public getSubscriptionCost = async (sportCode: string) => {
    try {
      const userInfo = localStorageService.getUserInfo();
      const token = userInfo?.token;

      const inflightKey = `${sportCode}|${token || ""}`;
      const existing = this.inflightRequests.get(inflightKey);
      if (existing) return await existing;

      const headers: Record<string, string> = {
        Accept: "application/json",
      };
      if (token) headers.Authorization = `Bearer ${token}`;

      const request = api
        .get<SubscriptionCostResponse>(`${SUBSCRIPTION_COST}?sport_code=${encodeURIComponent(sportCode)}`, {
          headers,
        })
        .then((response) => response)
        .catch((error: any) => error?.response || error)
        .finally(() => {
          this.inflightRequests.delete(inflightKey);
        });

      this.inflightRequests.set(inflightKey, request);
      return await request;
    } catch (error: any) {
      return error?.response || error;
    }
  };
}

const subscriptionCostService = new SubscriptionCostService();
export default subscriptionCostService;
